<template>
  <div class="global-auth-box d-flex justify-center align-center" @click="show = false">
    <div class="g-auth-box" @click.stop>
      Are you sure you want to logout?

      <div class="dx-flex justify-space-between gl-action">
        <div class="op-btn btn-md btn-block btn-secodary" @click="show = false">No</div>
        <div class="op-btn btn-md btn-block btn-danger" @click="proceedLogout">Yes</div>
      </div>
    </div>
  </div>
</template>

<script>
import WidgetSession from '@/modules/session'
const cookie = require('vue-cookie')

export default {
  name: 'logout',
  data () {
    return {
      session: ''
    }
  },
  computed: {
    user () { return this.$store.state.user },
    logoutStore () { return this.$store.state.global.logout },
    show: {
      get () { return this.logoutStore.show },
      set (x) { this.$store.commit('global/setLogoutData', {show: x}) }
    }
  },
  methods: {
    proceedLogout () {
      this.session.destroy()
      this.$store.commit('user/reset')
      cookie.delete('userToken')
      this.$store.commit('cards/setCardData', {
        lastUserID: '',
        list: []
      })
      this.$store.commit('setCredits', 0)
      this.$store.commit('booking/setOthersData', {bookAsGuest: true})
      this.$store.commit('booking/cleanTravellerInfo')
      this.$store.commit('global/setLogoutData', {
        show: false,
        success: true
      })
      this.$store.commit('user/setIsCorporate', false)
    }
  },
  mounted () {
    this.session = new WidgetSession(this)
  }
}
</script>

<style lang="scss" scoped>
.global-auth-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0,0,0, .3);
  z-index: 2;
}
.g-auth-box{
  background: #f9f9f9;
  border-radius: 4px;
  box-shadow: 2px 2px 4px rgba(0,0,0, .3);
  padding: 20px;
  width: 100%;
  max-width: 400px;
  text-align: center;
}
.gl-action{
  margin-top: 30px;
  gap: 20px;
}
.btn-secodary{
  border: none;
}
</style>


// WEBPACK FOOTER //
// Logout.vue?4d1f7dc9